// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2M5K1","rightAdornment":"Header_rightAdornment__2bIPd"};